import type { ReactNode } from "react"

import { Ground } from "@/components/ground/ground"
import { ImpersonationBanner } from "@/components/impersonation-banner"
import { Toaster } from "@/components/ui/sonner"
import { useFlash } from "@/hooks/use-flash"
import { PostHogIdentityProvider } from "@/providers/PostHogIdentityProvider"
import { RouterProvider } from "@/providers/RouterProvider"

interface PersistentLayoutProps {
  children: ReactNode
}

/*
 * Persists across Inertia visits. The ground lives here so that it is one
 * element from page to page: an index leaves its still behind for the subject
 * page to resolve, rather than each page mounting a map of its own.
 */
export default function PersistentLayout({ children }: PersistentLayoutProps) {
  useFlash()
  return (
    <PostHogIdentityProvider>
      <RouterProvider>
        <Ground />
        <ImpersonationBanner />
        {children}
        <Toaster richColors />
      </RouterProvider>
    </PostHogIdentityProvider>
  )
}
